export const FIELD_GROUPS = [
  {
    labelKey: "ncrm.workflows.staging.drawer.groupIdentification",
    fields: ["name", "legal_name", "fiscal_code", "vat_number", "registration_number", "iban"],
  },
  {
    labelKey: "ncrm.workflows.staging.drawer.groupContact",
    fields: [
      "website",
      "email_primary", "email_secondary", "email_tertiary",
      "phone_primary", "phone_secondary", "phone_tertiary",
    ],
  },
  { labelKey: "ncrm.workflows.staging.drawer.groupLocation", fields: ["address_text", "country"] },
  {
    labelKey: "ncrm.workflows.staging.drawer.groupBusiness",
    fields: [
      "industry", "business_category", "business_is_active", "company_size", "employees_count",
      "annual_revenue", "mitp_founded_year", "administrator_name",
    ],
  },
  { labelKey: "ncrm.workflows.staging.drawer.groupSocial", fields: ["instagram", "facebook", "linkedin"] },
  { labelKey: "ncrm.workflows.staging.drawer.groupMeta", fields: ["source", "tags"] },
];

export const CRM_REMAP_COLUMNS = [
  "name", "legal_name", "fiscal_code", "vat_number", "registration_number", "iban",
  "business_category", "business_is_active", "industry", "company_size", "employees_count",
  "annual_revenue", "mitp_founded_year", "mitp_company_type",
  "website",
  "email_primary", "email_secondary", "email_tertiary",
  "phone_primary", "phone_secondary", "phone_tertiary",
  "address_text", "country",
  "instagram", "facebook", "linkedin",
  "administrator_name", "source", "tags", "notes",
];

const CRM_FIELD_LABEL_KEYS = Object.freeze({
  country: "ncrm.workflows.staging.crmFields.country",
});

export const buildCrmRemapOptions = (translate) =>
  CRM_REMAP_COLUMNS.map((col) => {
    const labelKey = CRM_FIELD_LABEL_KEYS[col];
    const localized = labelKey && typeof translate === "function" ? translate(labelKey) : "";
    const label = localized && localized !== labelKey ? `${localized} (${col})` : col;
    return { value: col, label };
  });
